import React, { Fragment } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { SnackbarProvider } from 'notistack';
import {
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';

import Routers from '../../routers';

const useStyles = makeStyles((theme: Theme) => createStyles({
  info: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  error: {
    color: theme.palette.error.contrastText,
  },
}));

interface IProps {}

const AppComp: React.FC<IProps> = () => {
  const classes = useStyles();
  return (
    <SnackbarProvider
      maxSnack={100}
      classes={{
        variantInfo: classes.info,
      }}
    >
      <Fragment>
        <CssBaseline />
        <Routers />
      </Fragment>
    </SnackbarProvider>
  );
};

export default AppComp;
